module.exports = __webpack_public_path__ + "static/media/Doc2.c30b333e.jpg";